import type { SlotRegistry } from '../../../project_starburst';
import { DEFAULT_SLOT_REGISTRY } from '../../../project_starburst';

import { NoteNav } from './NoteNav';
import { NoteViewer } from './NoteViewer';

/**
 * The registry `CodingScreenShell`'s `registry` prop is given in production --
 * composed from `DEFAULT_SLOT_REGISTRY` (the in-folder registry: `PatientInfo`/`HoldAction`) plus
 * the out-of-folder note slots (`NoteNav`/`NoteViewer`), so every slot the coding default config
 * binds (`patientInfo`/`holdAction`/`docNav`/`viewer`) resolves to a real component.
 *
 * `CmxDocumentContentViewer` is deliberately NOT here: no config slot binds a `CmxDocumentContentViewer`
 * componentId -- `NoteViewer` renders it directly once its `activeNoteKey` selects the CMX Document
 * Content (see `noteInteractionContext.tsx`), bypassing the `Slot` resolver entirely. Registering it
 * here would be a second, dead entry point.
 */
export const CODING_SCREEN_SLOT_REGISTRY: SlotRegistry = {
  ...DEFAULT_SLOT_REGISTRY,
  NoteNav,
  NoteViewer
};
